import React from 'react';

import './styles.css';

export default function UnderMaintenance() {
  return (
    <div className="um-main">
      <img src="/under-maintenance.svg" width="650px" height="650px" />
    </div>
  );
}
